import ApiInstance from './instance'
import {
  IFacilityStatisticsDTO,
  IResidentStatisticsDTO,
  IStatementsBatchDashboardStatistics,
  IStatementsBatchStatisticsDTO,
  IStatementStatisticsDTO,
  IWorkStatisticsDTO,
  URL_MAPPING
} from '@zunta/configurations'

const { statistics: statisticsUrls } = URL_MAPPING

export default class StatisticsApi {
  instance: ApiInstance

  constructor (instance: ApiInstance) {
    this.instance = instance
  }

  async getBatchStatementsStatistics (batchId: number | string): Promise<IStatementsBatchStatisticsDTO> {
    return this.instance.doGet(`${statisticsUrls.prefix}${statisticsUrls.getStatementsBatchStatistics.path}/${batchId}`, {}, 'getBatchStacistics')
  }

  async getResidentStatistics (): Promise<IResidentStatisticsDTO | any> {
    return this.instance.doGet(`${statisticsUrls.prefix}${statisticsUrls.getResidentsStatistics.path}`)
  }

  async getFacilityStatistics (): Promise<IFacilityStatisticsDTO | any> {
    return this.instance.doGet(`${statisticsUrls.prefix}${statisticsUrls.getFacilityStatistics.path}`)
  }

  async getStatementsStatistics (): Promise<IStatementStatisticsDTO> {
    return this.instance.doGet(`${statisticsUrls.prefix}${statisticsUrls.getStatementsStatistics.path}`)
  }

  async getBatchStatementsDashboardStatistics (batchId: number | string): Promise<IStatementsBatchDashboardStatistics> {
    return this.instance.doGet(`${statisticsUrls.prefix}${statisticsUrls.getStatementsBatchDashboardStatistics.path}/${batchId}`)
  }

  async getWorkStatistics (): Promise<IWorkStatisticsDTO> {
    return this.instance.doGet(`${statisticsUrls.prefix}${statisticsUrls.getWorkStatistics.path}`)
  }

  async getBatchLettersStatistics (batchId: number | string): Promise<IStatementsBatchStatisticsDTO> {
    return this.instance.doGet(`${statisticsUrls.prefix}/getBatchLettersStatistics/${batchId}`, {})
  }
}
